export default function isProduction(): boolean {
  return window.location.host === 'web.zid.sa';
}
